import gql from 'graphql-tag';

export default gql`
    fragment DeceasedPhotos on Funeral {
        DeceasedPhotos {
            ... on File {
                ID
                AbsoluteLink
                Name
            }
            ... on Image {
                ID
                AbsoluteLink
                Name
            }
        }
    }
`;
export const Prearrangement = gql`
    fragment PrearrangementPhotos on Prearrangement {
        Photos {
            ... on File {
                ID
                AbsoluteLink
                Name
            }
            ... on Image {
                ID
                AbsoluteLink
                Name
            }
        }
    }
`;
